export default {
  SHOW: '@AUTH_GATEWAY/OVERLAY_LOADER/SHOW',
  HIDE: '@AUTH_GATEWAY/OVERLAY_LOADER/HIDE',
};
